<template>
  <div class="content-card">
    <div
      v-if="memory.vimeo_id || memory.preview_urls"
      class="content-card__side content-card__side-preview"
    >
      <div :style="sideStyles" class="content-card__side-preview-bg"></div>
      <v-responsive class="content-card__video" :aspect-ratio="480 / 280">
        <VimeoPlayer v-if="memory.vimeo_id" :vimeoId="memory.vimeo_id" />
        <div
          class="content-card__image"
          v-else-if="memory.preview_urls"
          :style="{ backgroundImage: `url(${memory.preview_urls.large})` }"
        />
      </v-responsive>
    </div>
    <MemoryCopyWish v-if="pageSlug === 'birthday'" :memory="memory" />
  </div>
</template>

<script>
import MemoryCopyWish from "./MemoryCopyWish";

export default {
  components: {
    MemoryCopyWish,
  },
  name: "Memory",
  props: {
    memory: Object,
    color: String,
    pageSlug: String,
  },
  computed: {
    sideStyles() {
      return {
        backgroundColor: this.color,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.content-card {
  &__image {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-size: contain;
    background-position: center;
  }
}

</style>
